<div *transloco="let t; prefix: 'registration.page.summary'">
  <div class="form-container">
    <div class="summary-section">
      <div class="summary-section-title">
        <span class="material-icons">person</span>
        {{ t('userDetails') }}
        <button class="summary-section-edit-btn" (click)="editStep.emit(1)" [attr.aria-label]="'Nutzerdaten bearbeiten'">
          <span class="material-icons">edit</span>
        </button>
      </div>
      <htx-data-display [data]="userDetails()"></htx-data-display>
    </div>

    <div class="summary-section">
      <div class="summary-section-title">
        <span class="material-icons">business</span>
        {{ t('organisationGroups.basic') }}
        <button class="summary-section-edit-btn" (click)="editStep.emit(2)" [attr.aria-label]="'Organisationsdaten bearbeiten'">
          <span class="material-icons">edit</span>
        </button>
      </div>
      <htx-data-display [data]="organisationDetails()"></htx-data-display>
    </div>

    <div class="summary-section">
      <div class="summary-section-title">
        <span class="material-icons">verified</span>
        {{ t('organisationGroups.verification') }}
        <button class="summary-section-edit-btn" (click)="editStep.emit(3)" [attr.aria-label]="'Verifikationsdaten bearbeiten'">
          <span class="material-icons">edit</span>
        </button>
      </div>
      <htx-data-display [data]="organisationVerificationDetails()"></htx-data-display>
    </div>
  </div>
</div>
